<template>
	<div>
		<buttonlist @help="help" @search="search" ref="SetBtn"></buttonlist>
		<div>
			<el-button type="primary" size="mini" @click="apportion" :disabled="selectData.length == 0">{{$t('getapi[13418]')}}</el-button>
		</div>
		<el-table
			:data="dataSet"
			v-loading="loading"
			:highlight-current-row="true"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			@selection-change="handleSelectionChange"
			header-row-class-name="headerclass"
			style="width: 100%; margin-top:0px"
			:header-cell-style="$limits.headerClass"
		>
			<el-table-column type="selection"></el-table-column>
			<el-table-column show-overflow-tooltip prop="invoice_no" :label="$t('getapi[2992]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[1936]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="create_date" :label="$t('getapi[135]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="pur_measure" :label="$t('getapi[916]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="receive_qty" :label="$t('getapi[1628]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="remain_material_unit" :label="$t('getapi[13413]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="rec_p_material_cost" :label="$t('getapi[13414]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="settled_qty" :label="$t('getapi[13448]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="settlement_qty" :label="$t('getapi[13415]')" align="right">
				<template scope="scope" >
					<el-input v-model="scope.row.settlement_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" @change="changeQty(scope)"></el-input>
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="invoice_qty" :label="$t('getapi[2995]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="net_unit_price" :label="$t('getapi[13416]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="line_net_total_amount" :label="$t('getapi[13417]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="vender_code" :label="$t('getapi[1196]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="vender_Name" :label="$t('getapi[1197]')"></el-table-column>
		</el-table>
		<el-row class="page">
			<el-col :span="18">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[100, 200, 300, 400]"
					:page-size="pageSize"
					:pager-count="5"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<serce :isVisible="isVisible" queryData="EstimateHandle" ref="ser" @getser="serclick"></serce>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'3_estimatehandle',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3  - Common.reduceTableHeight2,
                maxHeight: this.$windowSize.tableHeight3  - Common.reduceTableHeight2
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3  - Common.reduceTableHeight2
        }
    },
	data() {
		return {
            tableHeader:[],
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('3_estimatehandle'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
            scrollTop:0,
            type:'1',//1:上次入库成本2:上次出库成本3:结存成本
            selectData:[],
		};
	},
	mounted: function() {
		let that = this;
        that.colsort();
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        colsort() {
            let that = this;
            that.$loadviewfields.Fileds('EstimateHandle', 0, PFileds => {
                that.tableHeader = PFileds;
            });
        },
        sortclick(val) {
            if (val == 1) {
                this.colsort();
            }
        },
        // 修改表格顺序
        opentable() {
            this.$refs.ctab.clearInputs(true);
        },
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[959]"),this.$t("getapi[16]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetButtonEnable('search');
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('3_estimatehandle',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'EstimateHandle');
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				SelectIndex: that.SelectIndexs,
				Param: datac
			};
			that.$http.urlpost('/GL/Cost/GetEstimateHandleList', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
					that.authority();
				}
			});
		},
        handleSelectionChange(val) {
            let that = this;
            that.selectData = val
        },
        changeQty(row){
            let that = this
			let index = row.$index
			that.dataSet[index].line_net_total_amount = that.dataSet[index].settlement_qty * that.dataSet[index].net_unit_price
		},
        apportion(){
            let that = this
			for(let i=0;i<that.selectData.length;i++){
			    if(that.selectData[i].settlement_qty <=0){
			        that.$message.warning('不能输入0或者负数！')
					return
				}
			}
            let parm = that.selectData
            that.$http.urlpost('GL/Cost/Apportion', parm, function (res) {
                if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    that.getView()
                }
            })
        },
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
